import { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Card } from 'react-bootstrap';
import FormContainer from '../components/FormContainer';
import StayTop from '../components/StayTop';

const UnsubscribePage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setIsLoading(true);

        try {
            const response = await fetch('/api/users/unsubscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message);
                setEmail('');
            } else {
                setError(data.message || 'Failed to unsubscribe. Please try again.');
            }
        } catch (err) {
            setError('An error occurred. Please try again later.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col md={8} lg={6}>
                    <Card className="shadow-sm">
                        <Card.Body className="p-4">
                            <h1 className="text-center mb-4">Unsubscribe from Marketing Emails</h1>

                            <p className="text-center text-muted mb-4">
                                We're sorry to see you go! Enter your email address below to unsubscribe from our marketing emails.
                            </p>

                            {message && (
                                <Alert variant="success" className="mb-4">
                                    {message}
                                </Alert>
                            )}

                            {error && (
                                <Alert variant="danger" className="mb-4">
                                    {error}
                                </Alert>
                            )}

                            {!message && (
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="email" className="mb-3">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter your email address"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </Form.Group>

                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="w-100"
                                        disabled={isLoading || !email}
                                    >
                                        {isLoading ? 'Processing...' : 'Unsubscribe'}
                                    </Button>

                                    <p className="text-center text-muted mt-4 mb-0" style={{ fontSize: '14px' }}>
                                        <strong>Note:</strong> You will still receive important account-related emails such as order confirmations and password resets.
                                    </p>
                                </Form>
                            )}

                            {message && (
                                <div className="text-center mt-4">
                                    <a href="/" className="btn btn-outline-primary">
                                        Return to Homepage
                                    </a>
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                    <div className="text-center mt-4">
                        <p className="text-muted" style={{ fontSize: '14px' }}>
                            Changed your mind? You can update your email preferences in your{' '}
                            <a href="/profile">account settings</a> or contact us at{' '}
                            <a href="mailto:support@retrodayz.co.uk">support@retrodayz.co.uk</a>
                        </p>
                    </div>
                </Col>
            </Row>
            <StayTop />
        </Container>
    );
};

export default UnsubscribePage;